export const VNC_SERVER_KEY = 'epc_vncserver_display';
export const JOB_ID_KEY = 'Jobid';
export const PASSWORD_KEY = 'password';
export const DISCONNECT_MODAL_CONTENT = 'Please choose an action.';
export const SOCKET_PROXY_TARGET = 'websockify';
export const MSG_DISCONNECT = 'Disconnected Successfully';
export const MSG_NO_CONNECTION = 'Please choose a job to connect.';
export const DISCONNECT_MODAL_CANCEL_BTN = 'Cancel';
export const DISCONNECT_MODAL_REMOVE_BTN = 'Remove Job';
export const DISCONNECT_MODAL_TITLE = 'Disconnect';
export const STARTING_PORT = 6900;
